import { render, staticRenderFns } from "./avatarlinks.vue?vue&type=template&id=45ac8496&"
import script from "./avatarlinks.vue?vue&type=script&lang=js&"
export * from "./avatarlinks.vue?vue&type=script&lang=js&"
import style0 from "./avatarlinks.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports